import { Box, Container, Stack, Typography } from '@mui/material';
import { AutoAwesome as SparkleIcon } from '@mui/icons-material';

function InviteBanner() {
  return (
    <Box sx={{ background: 'linear-gradient(135deg, #4E28B5 0%, #7C5CD6 100%)' }}>
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.25}
          sx={{ py: 1.25, alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}
        >
          <SparkleIcon sx={{ color: 'white', fontSize: 20, flexShrink: 0 }} />
          <Typography fontWeight={600} sx={{ color: 'white', fontSize: { xs: '0.875rem', sm: '0.95rem' } }}>
            You've been personally invited to join CreatorCV as one of our selected creators.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}

export default InviteBanner;
